import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  id: "layout-sidenav",
  class: "layout-sidenav sidenav sidenav-vertical bg-dark"
}
const _hoisted_2 = { class: "sidenav-inner" }
const _hoisted_3 = {
  key: 0,
  class: "w-100"
}
const _hoisted_4 = {
  key: 0,
  class: "ms-2"
}
const _hoisted_5 = {
  class: "dropdown-menu position-absolute",
  id: "partner-select"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "me-2" }
const _hoisted_8 = {
  key: 0,
  class: "fa fa-check-circle text-primary"
}
const _hoisted_9 = {
  key: 1,
  class: "far fa-circle text-dark"
}
const _hoisted_10 = {
  key: 4,
  class: "sidenav-item"
}
const _hoisted_11 = { class: "sidenav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidenav_item = _resolveComponent("sidenav-item")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      "enter-active-class": "animate__animated animate__slideInLeft animate__faster",
      "leave-active-class": "animate__animated animate__slideOutLeft animate__faster"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.store.getters.partners.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "d-flex justify-content-between px-4 py-3 cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePartnerSelect && _ctx.togglePartnerSelect(...args)))
                  }, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.store.getters.partner ? _ctx.store.getters.partner.short_name : 'SP-ED'), 1),
                    (_ctx.store.getters.partners.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa", _ctx.selectPartnerMenu ? 'fa-chevron-down' : 'fa-chevron-left'])
                          }, null, 2)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_Transition, {
                    "enter-active-class": "animate__animated animate__fadeIn",
                    "leave-active-class": "animate__animated animate__fadeOut"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.getters.partners, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: ""
                          }, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.selectPartner(item)),
                              role: "menuitem",
                              href: "javascript:void(0)",
                              class: "dropdown-item d-flex justify-content-start align-items-center px-2 py-1"
                            }, [
                              _createElementVNode("div", _hoisted_7, [
                                (_ctx.store.getters.partner ? _ctx.store.getters.partner.id === item.id : false)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_9))
                              ]),
                              _createTextVNode(" " + _toDisplayString(item.short_name), 1)
                            ], 8, _hoisted_6)
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.selectPartnerMenu]
                      ])
                    ]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sidenav-divider mt-0" }, null, -1))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_sidenav_item, {
              to: {name:'dashboard'},
              label: "Dashboard",
              icon: "fas fa-tachometer-alt"
            }),
            (_ctx.showScenarios())
              ? (_openBlock(), _createBlock(_component_sidenav_item, {
                  key: 1,
                  to: {name:'scenario.list'},
                  label: "Scenarios",
                  icon: "fas fa-laptop-medical"
                }))
              : _createCommentVNode("", true),
            (_ctx.store.getters.user && _ctx.store.getters.user.props && _ctx.store.getters.user.props.super_admin == 1)
              ? (_openBlock(), _createBlock(_component_sidenav_item, {
                  key: 2,
                  to: {name:'rubric.list'},
                  label: "Rubrics",
                  icon: "fas fa-poll-h"
                }))
              : _createCommentVNode("", true),
            (_ctx.store.getters.hasPermission('applicant.view'))
              ? (_openBlock(), _createBlock(_component_sidenav_item, {
                  key: 3,
                  group: "",
                  label: "Recruitment",
                  icon: "fas fa-id-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_sidenav_item, {
                      label: "Pending",
                      icon: "fa fa-users",
                      to: {name:'recruitment.list'}
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.store.getters.user && _ctx.store.getters.user.props && _ctx.store.getters.user.props.super_admin == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createElementVNode("li", { class: "sidenav-divider mb-1" }, null, -1)),
                  _createVNode(_component_sidenav_item, {
                    group: "",
                    label: "Partner Management",
                    icon: "fas fa-handshake"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_sidenav_item, {
                        label: "Seat Management",
                        icon: "fas fa-chair",
                        to: {name:'management.seats'}
                      }),
                      _createVNode(_component_sidenav_item, {
                        label: "Pre-Approved Emails",
                        icon: "fas fa-thumbs-up",
                        to: {name:'management.pre-approved'}
                      }),
                      _createVNode(_component_sidenav_item, {
                        label: "Scheduling Dates",
                        icon: "fas fa-clock",
                        to: {name:'management.scheduling-dates'}
                      }),
                      _createVNode(_component_sidenav_item, {
                        label: "Registration Fields",
                        icon: "fas fa-clipboard",
                        to: {name:'management.registration-fields'}
                      }),
                      _createVNode(_component_sidenav_item, {
                        label: "Welcome Messages",
                        icon: "fas fa-door-open",
                        to: {name:'management.welcome-messages'}
                      }),
                      _createVNode(_component_sidenav_item, {
                        label: "Passwords",
                        icon: "fas fa-key",
                        to: {name:'management.passwords'}
                      }),
                      _createVNode(_component_sidenav_item, {
                        label: "Client Admin Requests",
                        icon: "fas fa-user-tie",
                        to: {name:'management.clients'}
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.store.getters.partner && _ctx.store.getters.partner.is_sim)
                    ? (_openBlock(), _createBlock(_component_sidenav_item, {
                        key: 0,
                        group: "",
                        label: "Quote Management",
                        icon: "fas fa-user-plus"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.store.getters.partner && _ctx.store.getters.partner.is_sim)
                            ? (_openBlock(), _createBlock(_component_sidenav_item, {
                                key: 0,
                                label: "Quote Requests",
                                icon: "fas fa-money-bill",
                                to: {name:'management.quotes'}
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.store.getters.partner && _ctx.store.getters.partner.is_sim)
                            ? (_openBlock(), _createBlock(_component_sidenav_item, {
                                key: 1,
                                label: "Invoice Requests",
                                icon: "fas fa-file-invoice",
                                to: {name:'management.invoices'}
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_sidenav_item, {
                    group: "",
                    label: "Social Media Posting",
                    icon: "fas fa-user-friends"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_sidenav_item, {
                        label: "Social Media Posts",
                        icon: "fas fa-hashtag",
                        to: {name:'management.social-media'}
                      }),
                      _createVNode(_component_sidenav_item, {
                        label: "Articles",
                        icon: "fas fa-newspaper",
                        to: {name:'management.articles'}
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_sidenav_item, {
                    label: "Manual Scheduling",
                    icon: "fa-regular fa-calendar-check",
                    to: {name:'management.manual-scheduling'}
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.store.getters.hasPermission('user.view_list'))
              ? (_openBlock(), _createBlock(_component_sidenav_item, {
                  key: 5,
                  to: {name: 'management.users'},
                  label: "User Management",
                  icon: "fas fa-users"
                }))
              : _createCommentVNode("", true),
            (_ctx.store.getters.hasPermission('project_report.access'))
              ? (_openBlock(), _createBlock(_component_sidenav_item, {
                  key: 6,
                  to: {name: 'availability.report'},
                  label: "SP Availability",
                  icon: "fas fa-calendar-check"
                }))
              : _createCommentVNode("", true),
            (_ctx.store.getters.partner && _ctx.store.getters.partner.is_sim && _ctx.userIsClientAdmin(0))
              ? (_openBlock(), _createBlock(_component_sidenav_item, {
                  key: 7,
                  label: "Agreements",
                  icon: "fas fa-file-contract",
                  to: {name:'PartnerAgreements'}
                }))
              : _createCommentVNode("", true),
            (_ctx.store.getters.partner && _ctx.store.getters.partner.is_sim && _ctx.userIsClientAdmin(1))
              ? (_openBlock(), _createBlock(_component_sidenav_item, {
                  key: 8,
                  label: "Landing Page Config",
                  icon: "fas fa-pen-fancy",
                  to: {name:'management.partners'}
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                class: "sidenav-link"
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "fa fa-sign-out-alt me-2" }, null, -1),
                _createElementVNode("div", null, "Logout", -1)
              ]))
            ])
          ])
        ])), [
          [_vShow, _ctx.isOpen],
          [_directive_click_outside, _ctx.hamburgerClose]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      class: "layout-overlay layout-sidenav-toggle"
    }, null, 512), [
      [_vShow, _ctx.isOpen]
    ])
  ], 64))
}